import { State } from "infrontjs";

/**
 * Base for the full-screen auth states (Login, Signup). They render into the
 * empty #main-wrapper that <app-layout> emits while logged out, and may only
 * be entered when there is no user.
 */
export class AuthState extends State
{
    static ROUTE = null;
    static ID = null;

    canEnter()
    {
        return this.app.user === null;
    }

    getRedirectUrl()
    {
        // Already signed in → go to the home tab. Literal to avoid a circular
        // import (HomeState → InAppState chain).
        return "/";
    }

    /** Render a full-screen auth template into the layout host. */
    renderAuth( template, data = {} )
    {
        const host = this.app.container.querySelector( "#main-wrapper" ) || document.body;
        this.app.view.render( host, template, data );
        return host;
    }
}
